import { NOT_SELECTED_ERROR } from '../../constants'

const validate = ({ catalogRefIds }) => {
  const errors = {}

  if (!(catalogRefIds && catalogRefIds.length)) {
    errors.catalogRefIds = NOT_SELECTED_ERROR
    errors._error = NOT_SELECTED_ERROR
  }

  return errors
}

export default validate
